import React from 'react'
import './About.css'

function About() {
  return (
    <div className='about' id='about'>
      <h2>About Us</h2>
      <div className='about-container'>
        <div className='about-image' />
        <div className='about-content'>
          <p>
            RastegHub is a product-driven tech innovation hub focused on building impactful digital
            solutions for both individuals and businesses. We develop and maintain a growing suite of
            products designed to solve real-world problems, improve efficiency, and create seamless
            user experiences. At the same time, we partner with businesses, startups, and organizations
            to design and build custom software tailored to their unique needs.
          </p>
          <p>
            Whether it's launching a new idea, optimizing operations, or scaling existing systems, we
            combine creativity, technical expertise, and a deep understanding of modern technology to
            deliver solutions that are reliable, scalable, and future-ready. At RastegHub, we don't just
            build software, we create tools and systems that empower growth, innovation, and long-term
            success.
          </p>
          <a href="/quote" className='about-cta'>
            Work with us →
          </a>
        </div>
      </div>
    </div>
  )
}

export default About